/** Chave do sessionStorage com o Mermaid a importar ao abrir um projeto Studio ("Abrir no Studio"). */
export const STUDIO_IMPORT_KEY = (roomId: string) => `studio-import:${roomId}`
